import * as yup from "yup";

export const validationSchema = yup.object().shape({
  reason: yup.string().required("停止理由を選択してください。"),
});
